import { DefaultTheme, ThemeProvider } from 'styled-components';
import create from 'zustand';
import { ThemeMode, ThemeUnit } from 'common/utils/helpers/theme';
import { generateTheme } from 'common/utils/helpers/theme.helpers';
import React from 'react';

interface ThemeStore {
  theme: DefaultTheme;
  toggleMode: () => void;
}

const MODES: ThemeMode[] = ['light', 'dark'];

const UNIT: ThemeUnit = 'px';

/**
 * @function useThemeStore
 * @usage
 * const { mode, toggleMode, theme } = useThemeStore()
 * -------------------------------------------------------
 * @default
 * mode = "light"
 * unit = "px"
 */
export const useThemeStore = create<ThemeStore>((set) => ({
  theme: generateTheme(MODES[0] as ThemeMode, UNIT),
  toggleMode: (): void => {
    set((state) => ({
      theme: generateTheme(MODES[1 - MODES.indexOf(state.theme.name)], UNIT),
    }));
  },
}));

/**
 * Provides theme for the whole application
 **/
export const AppThemeProvider: React.FC = (props) => {
  const { theme } = useThemeStore();

  // @ts-ignore
  return <ThemeProvider {...props} theme={theme} />;
};
